/* eslint-disable jsx-a11y/no-onchange */

import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { pageSizeChanged } from '../../actions/lister-actions';
import TRANSLATIONS from '../../translations/translations@default.json';
import { cookie, scrollToTopOfLister } from '../../utilities/lister-utilities';

export const ProductsPerPage = () => {
	const { pages: { AvailablePageSizes } = {}, isDealsPage } = useSelector(
		(state) => state
	);

	const cookieName = `${isDealsPage ? 'Deals' : 'New'}DefaultPageSize`;

	const dispatch = useDispatch();

	const cookiePageSize = cookie(cookieName).get();

	const pagesize = cookiePageSize ? parseInt(cookiePageSize, 10) : 12;

	const [currentPageSize, setCurrentPageSize] = useState(
		AvailablePageSizes
			? AvailablePageSizes.map((item) => item.Size).indexOf(pagesize)
			: 0
	);

	const handleChange = (event) => {
		if (AvailablePageSizes) {
			const option = AvailablePageSizes[event.target.value];

			setCurrentPageSize(event.target.value);

			dispatch(pageSizeChanged(option));

			cookie(cookieName).set(option.Size, 30);

			const listerAppContainer = document.getElementById('app');

			scrollToTopOfLister(listerAppContainer);
		}
	};

	if (!AvailablePageSizes || AvailablePageSizes.length === 0) {
		return null;
	}

	return (
		<React.Fragment>
			<div className="text-title-sm mr-2 hidden lg:inline">
				{TRANSLATIONS.controls.productsPerPage.show}
			</div>
			<label className="c-input-container" htmlFor="selectSize">
				<select
					id="selectSize"
					value={currentPageSize}
					className="text-body-xs pr-8 bg-white"
					style={{ minWidth: '70px' }}
					onChange={(event) => handleChange(event)}
					data-tag-name="products-per-page-clicked"
					data-tag-products={AvailablePageSizes[currentPageSize]?.Size}
					data-testid="selectsize">
					{AvailablePageSizes.map((option, index) => {
						return (
							<option
								key={`size-${option.Size}`}
								value={index}
								label={option.Size}>
								{option.Size}
							</option>
						);
					})}
				</select>
				<div className="text-base">
					<i
						className="ico ico-chevron-down absolute ico-lg text-cta-action pointer-events-none"
						style={{ top: '50%', right: '12px', transform: 'translateY(-50%)' }}
					/>
				</div>
			</label>
			<div className="text-title-sm text-sm none hidden xl:inline-block ml-2">
				{TRANSLATIONS.controls.productsPerPage.productsPerPage}
			</div>
		</React.Fragment>
	);
};

export default ProductsPerPage;
